<template>
  <div id="container">
    <div class="item-box-content">
      <div class="title-font-style">
        <span>仓内调拨</span>
      </div>
    </div>
    <div>
      <el-form class="search-style" label-width="70px" :model="queryParams">
        <el-row :gutter="20">
          <el-col :span="8" style="padding-left:0px !important">
            <el-form-item label="仓库：">
              <el-select v-model="queryParams.id" @change="onSelect" placeholder="请选择">
                <el-option
                  v-for="(item,index) in stockSelect"
                  :key="index"
                  :label="item.storageName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="调出货架：">
              <el-select @change="onSelect1" v-model="queryParams.fromSsId">
                <el-option
                  v-for="(item,index) in shelfSelect"
                  :key="index"
                  :label="item.shelvesName"
                  :value="item.ssId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="调入货架：">
              <el-select @change="onSelect2" v-model="queryParams.targetShelvesName">
                <el-option
                  v-for="(item,index) in holdShelfSelect"
                  :key="index"
                  :label="item.shelvesName"
                  :value="item.shelvesName"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top:15px !important;">
          <el-col :span="6" style="padding-left:0px !important">
            <el-form-item label="时间：" v-model="params.value">
              <el-date-picker
                v-model="time"
                style="width:97%;"
                type="daterange"
                @change="changeTime"
                range-separator="-"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd HH:mm"
                :default-time="['00:00:00','23:59:59']"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="4" style="padding-left:0px !important">
            <el-button type="primary" @click="onSearch">搜索</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-col>
          <el-col :span="14" style="text-align: right;">
            <el-button type="primary" @click="onNewAdd('',0)">新增</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div class="box-table" :style="{height:tableHeight+'px'}">
        <el-table
          border
          ref="tableRef"
          tooltip-effect="dark"
          :data="list"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          :max-height="tableHeight"
          element-loading-spinner="el-icon-loading"
        >
          <el-table-column label="仓库" width="140px">
            <template slot-scope="scope">
              <div>{{scope.row.storageName}}</div>
            </template>
          </el-table-column>
          <el-table-column label="调出货架">
            <template slot-scope="scope">
              <span>{{scope.row.fromShelvesName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="调入货架">
            <template slot-scope="scope">
              <span>{{scope.row.targetShelvesName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="调拨人">
            <template slot-scope="scope">
              <div>{{scope.row.createUser}}</div>
            </template>
          </el-table-column>
          <el-table-column label="时间">
            <template slot-scope="scope">
              <div>{{scope.row.createDate|dateFilterL}}</div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="200px">
            <template slot-scope="scope" fixed="right">
              <el-button type="text" @click="onNewAdd(scope.row,1)">查看</el-button>
              <el-button type="text" @click="exportWarehousing(scope.row)">导出</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination" style="padding-top:20px">
        <pagination
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
    <!--------------------------------- 新增，查看 弹窗 ------------------------------------------------>
    <transfer-stock-bank ref="transferStockBankRefs" @addAllocation="addAllocation"></transfer-stock-bank>
  </div>
</template>
<script>
import pagination from '@/components/pagination'
import transferStockBank from './dialog/transferStockBank'
import { queryBySbIdSsId, queryAllocation, querySsIdBySbIdAndSsId } from '@/api/storage/storage'
import { downLoadFileBlob } from '@/util/tool'
import { addAllocationCoeDerive } from '@/api/purchase/purchaseManage'
export default {
  components: {
    'transfer-stock-bank': transferStockBank,
    pagination
  },
  data () {
    return {
      tableHeight: window.innerHeight - 460,
      tempList: [],
      stockSelect: [], // 仓库列表
      shelfSelect: [], // 货架列表
      holdShelfSelect: [], // 调出货架
      queryParams: {
        // 查询货架信息传参数
        id: '', // 仓库id
        ssId: '', // 调出货架id
        sssId: '', // 调入货架id
        createDate: '',
        fromShelvesName: '',
        storageName: '',
        targetShelvesName: ''
      },
      list: [], // 列表数据
      loadingTable: false, // 列表loading
      processState: 1,
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0,
      time: [],
      params: {
        endValue: '',
        value: ''
      },
      lists: []
    }
  },
  mounted () {
    this.gethouseList()
    this.getList()
  },
  methods: {
    // 获取仓库信息
    async gethouseList () {
      this.stockSelect = await this.$houseInformation()
      if (this.queryParams.id) {
        this.onSelect(this.queryParams.id)
      }
    },
    exportWarehousing (row) {
      const queryParams = {}
      queryParams.allocationNumber = row.allocationNumber
      queryParams.allocationUrl = this.$store.state.storeManagementList

      addAllocationCoeDerive(queryParams)
        .then((res) => {
          downLoadFileBlob(this, res)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    changeTime (val) {
      if (this.tempList.some(ele => ele.column === 'createDate')) {
        this.tempList.forEach(ele => {
          if (ele.column === 'createDate') {
            ele.value = val[0]
            ele.endValue = val[1]
          }
        })
      } else {
        const obj = {
          column: 'createDate',
          value: val[0],
          endValue: val[1]
        }
        this.tempList.push(obj)
      }
    },
    onSelect2 (val) {
      if (this.tempList.some(ele => ele.column === 'targetShelvesName')) {
        this.tempList.forEach(ele => {
          if (ele.column === 'targetShelvesName') {
            ele.value = val
          }
        })
      } else {
        const obj = {
          column: 'targetShelvesName',
          value: val
        }
        this.tempList.push(obj)
      }
    },
    onSelect1 (id) {
      // 调出货架更新-调入货架也会更新
      this.queryParams.targetShelvesName = ''
      querySsIdBySbIdAndSsId(this.queryParams.id, id).then(res => {
        if (res.data.code === 200) {
          this.holdShelfSelect = res.data.obj
        }
      })
      if (this.tempList.some(ele => ele.column === 'fromSsId')) {
        this.tempList.forEach(ele => {
          if (ele.column === 'fromSsId') {
            ele.value = id
          }
        })
      } else {
        const obj = {
          column: 'fromSsId',
          value: id
        }
        this.tempList.push(obj)
      }
    },
    // 详细资料 -> 获取货架
    onSelect (id) {
      // 仓库变化 更新货架
      this.queryParams.fromSsId = ''
      this.queryParams.targetShelvesName = ''
      // 循环仓库数组，通过仓库id拿到对应的仓库名称并赋值给storageName
      this.stockSelect.forEach(item => {
        if (item.id === id) {
          this.queryParams.storageName = item.storageName
        }
      })
      if (this.tempList.some(ele => ele.column === 'storageName')) {
        this.tempList.forEach(ele => {
          if (ele.column === 'storageName') {
            ele.value = ele.storageName
          }
        })
      } else {
        const obj = {
          column: 'storageName',
          value: this.queryParams.storageName
        }
        this.tempList.push(obj)
      }
      this.shelfSelect = []
      queryBySbIdSsId(id)
        .then(res => {
          if (res.data.code === 200) {
            this.shelfSelect = res.data.obj
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 表格
    getList () {
      this.loadingTable = true
      this.tempList.forEach(ele => {
        ele.collection = true
      })
      const params = {
        criteriaVoList: [...this.lists],
        queryPageName: ''
      }
      queryAllocation(this.currentPage, this.pageSize, params)
        .then(res => {
          if (res.data.code === 200) {
            this.list = res.data.obj.records
            this.total = res.data.obj.total
            this.loadingTable = false
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 查询
    onSearch () {
      if (
        !this.queryParams.storageName &&
        !this.queryParams.fromSsId &&
        !this.queryParams.targetShelvesName &&
        this.time.length === 0
      ) {
        this.$message.error('搜索条件不能为空')
      } else {
        this.pageSize = 30
        this.currentPage = 1
        this.lists = this.tempList
        this.getList()
      }
    },
    // 重置
    onReset () {
      this.lists = []
      this.currentPage = 1
      this.pageSize = 30
      this.queryParams = {}
      this.tempList = []
      this.time = []
      // 清空调入调出货架下拉框
      this.shelfSelect = []
      this.holdShelfSelect = []
      this.getList()
    },
    // 新增 查看 弹窗
    onNewAdd (row, type) {
      this.$refs.transferStockBankRefs.onInitialize(row, type)
    },
    // 新增保存页面传值
    addAllocation (val) {
      this.getList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 页数
    handleSizeChange (val) {
      this.currentPage = 1
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}

</script>
<style lang="scss" scoped>
.number-yet,
.number-wait,
.number-yetCreate {
  bottom: 14px;
  left: 122px;
}
.number-wait {
  left: 245px;
}
.number-yetCreate {
  left: 365px;
}
</style>
